/** 模板变量表单的纯逻辑，方便单测。 */
import type { TemplateVar } from '../api/client';

/** 用模板变量的 default 生成表单初值 */
export function defaultVarValues(vars: TemplateVar[]): Record<string, string> {
  return Object.fromEntries(vars.map((v) => [v.key, v.default ?? '']));
}

/**
 * 组装提交参数：用户留空的字段回落到 default，只保留模板声明过的 key。
 * 服务端同样会回落 default，这里先做一遍是为了 title 预览与可预期的请求体。
 */
export function buildCreatePayload(templateId: string, vars: TemplateVar[], values: Record<string, string>) {
  const merged: Record<string, string> = {};
  for (const v of vars) {
    const raw = values[v.key];
    merged[v.key] = raw !== undefined && raw.trim() !== '' ? raw.trim() : v.default ?? '';
  }
  return { templateId, vars: merged };
}

/** 本地预览：把 {{key}} 替换成变量值（服务端做真正的替换） */
export function applyVars(text: string, values: Record<string, string>): string {
  return text.replace(/\{\{\s*([\w-]+)\s*\}\}/g, (_, k: string) => values[k] ?? '');
}
